export enum EnergyValveState {
  Undefined = 0,
  Ok = 1, // Ok
  Warning = 2, // Warning
  NotOk = 3,  //NotOk
}